module.exports = __webpack_public_path__ + "img/IMG_8833_web_dominic.17fbd702.jpg";